/**
 * Instantiates class from json
 */
export class Deserializable {
  /**
   * deserializes a stringified object into a class T
   * @param {T} type
   * @return {function(json: string): T}
   */
  static deserialize<T>(type: new () => T): (json: string) => T {
    return (json: string): T => {
      const t = new type();
      const jsonObj = JSON.parse(json);

      /* eslint-disable */
      for (const propName in jsonObj) {
        (t as any)[propName] = jsonObj[propName];
      }
      /* eslint-enable */
      return t;
    };
  }

  /**
   * @return {string}
   */
  serialize(): string {
    return JSON.stringify(this);
  }
}
